import DocumentCreationButton from 'Components/DocumentCreationButton';
import DocumentHeader from 'Components/DocumentHeader';
import DocumentWrapper from 'Components/DocumentWrapper';
import { FormContextProvider, HistoryContextProvider } from 'Containers/FormContextHandler';
import FormEditingHandler from 'Containers/FormEditingHandler';
import * as React from 'react';
import Form from './Form';
import ChecklistHistory from './HistoryRowData';

const DEFAULT_DOCUMENTS: IOwnProps['documents'] = [];

const Checklist = ({ documents = DEFAULT_DOCUMENTS }: IOwnProps): React.JSX.Element => (
  <FormEditingHandler name="checklist" documents={documents}>
    {(editing, startEdit, formData, view): React.JSX.Element => (
      <DocumentWrapper>
        <DocumentHeader
          headerId={'checklist.title'}
          infoText={'checklist.infoText'}
          editing={editing || view?.viewing}
          editButtons={
            <div>
              <DocumentCreationButton name="checklist" text={'general.new'} onClick={startEdit({})} />
            </div>
          }
        />
        {!view?.viewing && !editing && documents ? (
          <HistoryContextProvider context={{ documents, startEdit, view }}>
            <ChecklistHistory />
          </HistoryContextProvider>
        ) : undefined}
        {view?.viewing || editing ? (
          <FormContextProvider context={{ documents, formData, editing, view }}>
            <Form />
          </FormContextProvider>
        ) : undefined}
      </DocumentWrapper>
    )}
  </FormEditingHandler>
);

interface IOwnProps {
  documents?: IDocumentWithTypeV2<'checklist'>[];
}

export default Checklist;
